import {modals} from "../modals/init-modals";

const crmRequest = 'https://hermes.smile-tech.study/api/v1/lead?programId=';

const baseSuccessCallback = (event) => {
  event.preventDefault();
  const formData = Object.fromEntries(new FormData(event.target));
  formData['Landing'] = document.location.href.split('?')[0] || document.location.href;

  if (formData['program_id']) {
    formData['program_id'] = Number(formData['program_id']);
  }
  if (formData['program_group_id']) {
    formData['program_group_id'] = Number(formData['program_group_id']);
  }

  const programId = formData['program_id'] || '';

  fetch(`${crmRequest}${encodeURIComponent(programId)}`, {
    method: "POST",
    headers: { "Content-Type": "application/json;charset=utf-8" },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      if (response.ok) {
        return response;
      }
      throw new Error(`${response.status} ${response.statusText}`);
    })
    .then(() => {
      ym(89966386,'reachGoal','FormSubmit');
      modals.open("submit-modal");
    })
    .catch(function (error) {
      console.log(error);
      modals.close("fail-modal");
    });
};

const baseErrorCallback = (event) => {
  event.preventDefault();
  // Данный коллбек используется при необходимости выполнить какое-либо действие помимо показа ошибок при попытке отправить неккорректные данные, он не связан с запросами на сервер
};

export const callbacks = {
  base: {
    // Сбросс формы
    reset: true,
    // Таймаут сброса формы
    resetTimeout: 500,
    successCallback: baseSuccessCallback,
    errorCallback: baseErrorCallback,
  },
};